/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductCategoryDto } from '../../models/product-category-dto';

export interface ProductCategoryControllerFindByType$Params {
  type: '\uB514\uC9C0\uD138\uC790\uB8CC' | '\uAD50\uAD6C' | '\uAD50\uC7AC';
}

export function productCategoryControllerFindByType(http: HttpClient, rootUrl: string, params: ProductCategoryControllerFindByType$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, productCategoryControllerFindByType.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductCategoryDto>>;
    })
  );
}

productCategoryControllerFindByType.PATH = '/api/product-category/{type}';
